import React, { Component } from 'react'
import TabComponent from '../TabComponent'
import MultiDropDown from '../MultiDropDown/MultiDropDown'
import DatePicker from '../DatePicker'
import TimePicker from '../TimePicker'
import { withStore } from '../store'
import MemberTRRInfo from './MemberTRRInfo'
import MemberEvents from './MemberEvents'
import MemberOptions from './MemberOptions'
import Alert from '../Alert'
import RadioButton from '../RadioButton'
import { Service } from '../ApiService'
import Loader from '../Loader'
import { alertNotValid, showMessage } from '../alerts'
import EditContact from '../EditContact';
import { memberValidators } from './memberValidators'
import DeleteUpSVG from '../../svg/DeleteUpSVG'
import SaveUpSVG from '../../svg/SaveUpSVG'
import CloseUpSVG from '../../svg/CloseUpSVG'
import ReturnUpSVG from '../../svg/ReturnUpSVG'
import { createValidators } from '../storeValidatorsRules'

import InputWithClearButton from '../InputWithClearButton'
import MemberEventOrders from './MemberEventOrders'
import ToggleButton from 'react-toggle-button';

import { Link } from 'react-router-dom'


class Member extends Component {

    constructor(props) {
        super(props);
        props.store.refreshUserInfo();
        let userId = "";
        if (props.match.params.id) {
            userId = props.match.params.id
        }
        this.state = {
            baseMember: {},
            member: {
                companyName: '',
                taxExempt: '',
                id: userId,
                siteId: 0,
                firstName: '',
                lastName: '',
                phone: '',
                email: '',

                streetAddress: '',
                city: '',
                state: '',
                zip: '',

                releaseSigned: false,
                liabilitySigned: false,
                activeMember: false,
                deactiveCause: '',
                joinDate: null,
                sponsoredById: null,
                roles: [],
                userType: 0,
                comments: '',
                events: [],
                options: [],
                status: 0,

                hasTaxExemptCertificate: false,
                deleteCertificate: false,

                taxExemptVerified: null,
                taxExemptExpirationDate: null,

                isAccountActivated: false
            },
            taxExemptCertificate: null,

            activeTabIndex: 0,
            showError: false,
            showDeleteMemberDialog: false,
            showSuccessfullySavedDialog: false,
            showErrorSaveDialog: false,
            userId: userId,
            sponsors: [],
            authLevels: []
        };
        this.stateDropDownRef = null;
        this.joinDateDropDownRef = null;
        //this.sponsoredByDropDownRef = null;
        this.statusDropDownRef = null;
        this.authLevelDropDownRef = null;
        this.userTypeDropDownRef = null;

        this.saveMemberInfo = this.saveMemberInfo.bind(this);
        this.close = this.close.bind(this);
        this.contactValidators = createValidators([
            { 'name': 'name', 'typeFunction': 'nameOTG', 'text': 'Name' },
            { 'name': 'phone', 'typeFunction': 'nameOTG', 'text': 'Phone' },
            { 'name': 'email', 'typeFunction': 'nameOTG', 'text': 'Email' },
        ]);

        this.fileRef = null;
        this.uploadBtnRef = null;
    }

    openFileDialog = () => {
        if (this.fileRef != null) {
            this.fileRef.click();
        }
    }

    downloadTaxExemptCertificateFile = () => {
        Service.download('/api/Profile/TaxExempt/' + this.state.member.id).then(blob => {
            Service.throwBlob(blob, 'taxExempt.pdf');
            this.setState({ loading: false });
        });
    }

    deleteTaxCertificate = (evt) => {
        var member = { ...this.state.member };
        member.hasTaxExemptCertificate = false;
        member.taxExemptExpirationDate = null;
        member.taxExemptVerified = null;
        member.deleteCertificate = true;

        this.setState(
            {
                member: member,
                taxExemptCertificate: null
            }
        );
    }

    uploadFileChanged = (evt) => {
        var member = { ...this.state.member };
        member.hasTaxExemptCertificate = true;
        member.deleteCertificate = false;

        this.setState(
            {
                member: member,
                taxExemptCertificate: evt.target
            },
            //() => {
            //    Service.uploadTaxExempt(this.state.member.id, this.state.taxExemptCertificate)
            //        .then(data => {
            //            this.setState(
            //                {
            //                    loading: false
            //                }
            //            );
            //        });
            //    }
        );

        /*
        var files = evt.target.files;

        for (var i = 0, f; f = files[i]; i++) {

            // Only process image files.
            if (!f.type.match('application/pdf')) {
                continue;
            }

            var reader = new FileReader();

            // Closure to capture the file information.
            reader.onload = (function (theFile) {
                return function (e) {
                    // Render thumbnail.
                    var byteCharacters = atob(e.target.result.substring(28));
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    var blob = new Blob([byteNumbers], { type: 'application/pdf' });
                    var url = URL.createObjectURL(blob);
                    window.open(url);
                };
            })(f);

            // Read in the image file as a data URL.
            reader.readAsDataURL(f);
        }
        */

        //var evtTarget = evt.target;
        //this.setState({ loading: true }, () => {
        //    Service.uploadTaxExempt(this.state.member.id, evtTarget)
        //        .then(data => {
        //            this.setState(
        //                {
        //                    hasTaxExemptCertificate: true,
        //                    taxExemptCertificate: data,
        //                    loading: false
        //                }
        //            );
        //        });
        //});
    }

    componentWillMount = () => {
        this.validators = memberValidators();
        this.alertNotValid = alertNotValid(() => this.setState({ showError: false }));
    }

    fixData(data) {
        if (data.joinDate != null) {
            data.joinDate = new Date(data.joinDate);
        }
        if (data.taxExemptExpirationDate != null) {
            data.taxExemptExpirationDate = new Date(data.taxExemptExpirationDate);
        }
        data.deleteCertificate = false;
        return data;
    }

    componentDidMount = () => {
        var onSuccess = (data) => {
            var fixedData = this.fixData(data);
            this.setState({
                loading: false,
                member: { ...fixedData },
                baseMember: { ...fixedData },
                taxExemptCertificate: null
            });
        };
        this.setState({ loading: true });
        Service.getBCCInfoLists().then(data => {
            this.setState({ /*sponsors: data.sponsors,*/ authLevels: data.roles });
            if (this.props.match.path == '/profile') {
                Service.getProfile().then(onSuccess);
            } else if (this.props.match.path == '/new-member') {
                this.setState({ loading: false });
            } else if (this.state.userId != null && this.state.userId != "") {
                Service.getProfileById(this.state.userId).then(onSuccess);
            }
        });
    }

    close() { this.props.history.goBack(); }

    checkMemberChanges = () => {
        var baseMember = this.state.baseMember;
        var changedMember = this.state.member;
        var hasChanges = false;

        var properties = Object.getOwnPropertyNames(changedMember);
        properties.map(property => {
            if (Array.isArray(baseMember[property])) {
                return false;
            }
            else {
                if (baseMember[property] != changedMember[property]) {
                    hasChanges = true;
                    return false;
                }
            }
            return false;
        });

        return hasChanges || this.state.taxExemptCertificate != null;
    }

    saveMemberInfo = () => {
        this.performIfValid(() => {
            this.setState({ loading: true }, () => {
                if (!this.checkMemberChanges()) {
                    this.setState({ loading: false });
                }

                var memberData = this.state.member;

                //if (this.state.taxExemptCertificate) {
                //    var fileArray = [];
                //    var taxExemptCertificate = this.state.taxExemptCertificate;
                //    let formData = new FormData();
                //    for (var i = 0; i < taxExemptCertificate.files.length; i++) {
                //        fileArray.push(taxExemptCertificate.files[i]);
                //    }
                //    memberData.TaxExemptCertificates = fileArray;
                //    memberData.taxExemptCertificates = fileArray;
                //}

                if (memberData) {
                    Service.setProfile(memberData).then(data => {
                        if (data === undefined) { this.setState({ loading: false, showErrorSaveDialog: true }) }
                        else {
                            var success = (data) => {
                                var fixedData = this.fixData(data);

                                this.setState({
                                    member: { ...fixedData },
                                    baseMember: { ...fixedData },
                                    loading: false,
                                    taxExemptCertificate: null,
                                    showSuccessfullySavedDialog: true
                                });
                            }


                            if (this.state.taxExemptCertificate) {
                                Service.uploadTaxExempt(data.id, this.state.taxExemptCertificate)
                                    .then(uploadData => {
                                        data.hasTaxExemptCertificate = true;
                                        success(data);
                                    });
                            }
                            else {
                                success(data);
                            }
                        }
                    }).catch(er => {
                        var mess = 'Something went wrong.';
                        console.log(typeof (er));
                        if (Array.isArray(er)) {
                            mess.forEach(a => { mess += '; ' + a; });
                        }
                        this.setState({ loading: false, showErrorSaveDialog: true, messageErrorSaveDialog: mess });
                    });
                }
            });
        });
    }

    updateMemberProperty(property, value) {
        let member = this.state.member;
        member[property] = value;
        this.setState({ member });
    }

    stateNameAndAbbrRender(element, textProperty) {
        return <span className='text-transform-none'>
            {element.name + ', ' + element.abbreviation}
        </span>
    }

    deleteMember() {
        Service.deleteProfile(this.state.member).then(this.close);
    }

    renderHeader() {
        if (this.props.match.path == '/profile') {
            return (<h1 className='uppercase-text mb-2'>My<strong> Profile</strong></h1>)
        } else if (this.props.match.path == '/new-member') {
            return (<h1 className='uppercase-text mb-2'>New<strong> Member</strong></h1>)
        } else {
            return (<h1 className='uppercase-text mb-2'>Edit<strong> Member</strong></h1>)
        }
    }

    getTabs() {
        if (this.props.match.path == '/profile') {
            return ['my info', 'my events', 'my orders'];
        } else {
            return ['personal info', 'events', 'orders'];//, 'TRR info', 'options'
        }
    }

    checkIfElementMeetsCriteria = (el, filterList, params) => {
        let checkParam = (param, elFilter) => {
            return el[param].toLowerCase().includes(elFilter)
        }
        let allParamsWereFound = true;
        filterList.forEach(elFilter => {
            if (!params.find(param => checkParam(param, elFilter))) {
                allParamsWereFound = false
            }
        })
        return allParamsWereFound;
    }

    searchValueIntoArray(filter) {
        /* remove all " " at the beginning and double ' ' inside the filter expression if they are there */
        filter = filter.replace(/\,+/g, ' ');
        filter = filter.toLowerCase().replace(/\s+/g, ' ');
        /* return an array of filters or empty string*/
        if (filter !== '') { return filter.split(" ") }
        else return '';
    }

    filterList = (list, filter, params) => {
        let filterList = this.searchValueIntoArray(filter);
        if (filterList === '') {
            return list;
        }
        else {
            let newList = [];
            list.forEach(element => {
                if (this.checkIfElementMeetsCriteria(element, filterList, params)) {
                    newList.push(element);
                }
            })
            return newList;
        }
    }

    performIfValid(callback) {
        if (this.props.store.isFormValid(this.validators, this.state.member)) { callback(); }
        else { this.setState({ showError: true }) };
    }

    getTabToRender = () => {
        switch (this.state.activeTabIndex) {
            case 0: return this.getInfoTab();
            case 1: return this.getEventsTab();
            case 2: return this.getOrdersTab();
            default: return '';
        }
    }

    getTaxExemptVerificationCtrl = () => {
        if (this.state.member.hasTaxExemptCertificate != true) {
            return '';
        }
        else if (this.props.store.userInfo != null && this.props.store.userInfo.authType == "Admin") {
            return <div>
                <RadioButton
                    style={{ "marginRight": "0.75rem" }}
                    radioGroupElement={this.state.member.taxExemptVerified}
                    radioButtonValue={true}
                    onClick={(value) => {
                        this.updateMemberProperty("taxExemptVerified", value);
                    }}
                    labelClassName="checkbox-text"
                    labelText='Valid'
                />
                <RadioButton
                    radioGroupElement={this.state.member.taxExemptVerified}
                    radioButtonValue={false}
                    onClick={(value) => {
                        this.updateMemberProperty("taxExemptVerified", value);
                    }}
                    labelClassName="checkbox-text"
                    labelText='Not valid'
                />
            </div>
        }
        else {
            switch (this.state.member.taxExemptVerified) {
                case true: return <strong>Verified</strong>;
                case false: return <strong style={{ 'color': 'red' }}>Not Verified</strong>;
                default: return <p className='message-block'>Pending verification</p>;
            }
        }
    }

    getInfoTab = () => {
        const stateList = [{ "name": "Alabama", "abbreviation": "AL" }, { "name": "Alaska", "abbreviation": "AK" }, { "name": "Arizona", "abbreviation": "AZ" }, { "name": "Arkansas", "abbreviation": "AR" }, { "name": "California", "abbreviation": "CA" }, { "name": "Colorado", "abbreviation": "CO" }, { "name": "Connecticut", "abbreviation": "CT" }, { "name": "Delaware", "abbreviation": "DE" }, { "name": "District of Columbia", "abbreviation": "DC" }, { "name": "Florida", "abbreviation": "FL" }, { "name": "Georgia", "abbreviation": "GA" }, { "name": "Hawaii", "abbreviation": "HI" }, { "name": "Idaho", "abbreviation": "ID" }, { "name": "Illinois", "abbreviation": "IL" }, { "name": "Indiana", "abbreviation": "IN" }, { "name": "Iowa", "abbreviation": "IA" }, { "name": "Kansas", "abbreviation": "KS" }, { "name": "Kentucky", "abbreviation": "KY" }, { "name": "Louisiana", "abbreviation": "LA" }, { "name": "Maine", "abbreviation": "ME" }, { "name": "Maryland", "abbreviation": "MD" }, { "name": "Massachusetts", "abbreviation": "MA" }, { "name": "Michigan", "abbreviation": "MI" }, { "name": "Minnesota", "abbreviation": "MN" }, { "name": "Mississippi", "abbreviation": "MS" }, { "name": "Missouri", "abbreviation": "MO" }, { "name": "Montana", "abbreviation": "MT" }, { "name": "Nebraska", "abbreviation": "NE" }, { "name": "Nevada", "abbreviation": "NV" }, { "name": "New Hampshire", "abbreviation": "NH" }, { "name": "New Jersey", "abbreviation": "NJ" }, { "name": "New Mexico", "abbreviation": "NM" }, { "name": "New York", "abbreviation": "NY" }, { "name": "North Carolina", "abbreviation": "NC" }, { "name": "North Dakota", "abbreviation": "ND" }, { "name": "Ohio", "abbreviation": "OH" }, { "name": "Oklahoma", "abbreviation": "OK" }, { "name": "Oregon", "abbreviation": "OR" }, { "name": "Pennsylvania", "abbreviation": "PA" }, { "name": "Rhode Island", "abbreviation": "RI" }, { "name": "South Carolina", "abbreviation": "SC" }, { "name": "South Dakota", "abbreviation": "SD" }, { "name": "Tennessee", "abbreviation": "TN" }, { "name": "Texas", "abbreviation": "TX" }, { "name": "Utah", "abbreviation": "UT" }, { "name": "Vermont", "abbreviation": "VT" }, { "name": "Virginia", "abbreviation": "VA" }, { "name": "Washington", "abbreviation": "WA" }, { "name": "West Virginia", "abbreviation": "WV" }, { "name": "Wisconsin", "abbreviation": "WI" }, { "name": "Wyoming", "abbreviation": "WY" }];
        return <div>
            <ul className='input-fields first-child-text-125 pl-1 pr-1'>
                <li>
                    <p>Company Name:</p>
                    <div className={this.props.store.checkIfShowError('companyName', this.validators) ? 'error-input-wrapper' : ''}>
                        <InputWithClearButton
                            type='text'
                            placeholder='Company Name'
                            value={this.state.member.companyName}
                            onChange={e => {
                                this.updateMemberProperty("companyName", e.target.value);
                                this.props.store.updateValidators("companyName", e.target.value, this.validators);
                            }}
                            onClearValue={() => {
                                this.updateMemberProperty("companyName", "");
                                this.props.store.updateValidators("companyName", "", this.validators);
                            }}
                        />
                        {this.props.store.displayValidationErrors('companyName', this.validators)}
                    </div>
                </li>
                <li>
                    <p>Exibitor Name:</p>
                    <div>
                        <InputWithClearButton
                            type='text'
                            placeholder='Exibitor Name'
                            value={this.state.member.exibitorName}
                            onChange={e => {
                                this.updateMemberProperty("exibitorName", e.target.value);
                            }}
                            onClearValue={() => {
                                this.updateMemberProperty("exibitorName", "");
                            }}
                        />
                    </div>
                </li>
                <li className='input-wrapper'>
                    <p>Tax Exempt Date:</p>
                    <div style={{ display: 'block' }}>
                        <ul className='input-fields flex-nowrap break-at-560 line-of-inputs-wrapper'>
                            <DatePicker
                                value={this.state.member.taxExemptExpirationDate}
                                onSelect={value => {
                                    this.updateMemberProperty("taxExemptExpirationDate", value);
                                }}
                            />
                            {/*<InputWithClearButton
                                    type='text'
                                    placeholder='Tax Exempt #'
                                    value={this.state.member.taxExempt}
                                    onChange={e => {
                                        this.updateMemberProperty("taxExempt", e.target.value);
                                        //this.props.store.updateValidators("taxExempt", e.target.value, this.validators);
                                    }}
                                    onClearValue={() => {
                                        this.updateMemberProperty("taxExempt", "");
                                        //this.props.store.updateValidators("taxExempt", "", this.validators);
                                    }}
                                />*/}
                            {/*<li className='input-wrapper' style={{ "flex": "0 0 100px" }}>*/}
                            {this.getTaxExemptVerificationCtrl()}

                            {/*<ToggleButton style={{ 'margin-top': '10px', 'marginTop': '10px', 'padding-top': '10px', 'paddingTop': '10px' }}
                                    value={!this.state.member.taxExemptVerified}
                                    
                                    thumbStyle={{ borderRadius: 2 }}
                                    trackStyle={{ borderRadius: 2 }}
                                    onToggle={(value) => {
                                        this.updateMemberProperty("taxExemptVerified", value);
                                    }} />
                            </li>*/}
                        </ul>


                        <div style={{ display: 'none' }}>
                            <input type="file" accept="application/pdf, .pdf" ref={el => this.fileRef = el} onChange={this.uploadFileChanged} />
                        </div>

                        <div style={{ 'display': 'flex' }}>
                            <button className='blue-text blue-link link'
                                ref={el => this.uploadBtnRef = el}
                                onClick={() => {
                                    if (this.state.taxExemptCertificate)
                                        return false;
                                    this.state.member.hasTaxExemptCertificate ? this.downloadTaxExemptCertificateFile() : this.openFileDialog();
                                }}>
                                <span>{this.state.member.hasTaxExemptCertificate ? (this.state.taxExemptCertificate ? this.state.taxExemptCertificate.files[0].name : 'View certificate') : 'Select certificate'}</span>
                            </button>
                            {this.state.member.hasTaxExemptCertificate &&
                                <button className='blue-text blue-link link ml-075'
                                    onClick={this.deleteTaxCertificate}>
                                    <span>Delete certificate</span>

                                </button>
                            }
                        </div>
                    </div>
                </li>
                <li>
                    <p>First Name:</p>
                    <div className={this.props.store.checkIfShowError('firstName', this.validators) ? 'error-input-wrapper' : ''}>
                        <InputWithClearButton
                            type='text'
                            placeholder='First Name'
                            value={this.state.member.firstName}
                            onChange={e => {
                                this.updateMemberProperty("firstName", e.target.value);
                                this.props.store.updateValidators("firstName", e.target.value, this.validators);
                            }}
                            onClearValue={() => {
                                this.updateMemberProperty("firstName", "");
                                this.props.store.updateValidators("firstName", "", this.validators);
                            }}
                        />
                        {this.props.store.displayValidationErrors('firstName', this.validators)}
                    </div>
                </li>
                <li className='input-wrapper'>
                    <p>Last Name:</p>
                    <div className={this.props.store.checkIfShowError('lastName', this.validators) ? 'input-wrapper error-input-wrapper' : 'input-wrapper'}>
                        <InputWithClearButton
                            type='text'
                            placeholder='Last Name'
                            value={this.state.member.lastName}
                            onChange={e => {
                                this.updateMemberProperty("lastName", e.target.value);
                                this.props.store.updateValidators("lastName", e.target.value, this.validators);
                            }}
                            onClearValue={() => {
                                this.updateMemberProperty("lastName", "");
                                this.props.store.updateValidators("lastName", "", this.validators);
                            }}
                        />
                        {this.props.store.displayValidationErrors('lastName', this.validators)}
                    </div>
                </li>
                <li className='input-wrapper' >
                    <p>Email:</p>
                    <div className={this.props.store.checkIfShowError('email', this.validators) ? 'error-input-wrapper' : ""}>
                        <input type='text'
                            placeholder='Email'
                            value={this.state.member.email}
                            onChange={e => {
                                this.props.store.updateValidators("email", e.target.value, this.validators);
                                this.updateMemberProperty("email", e.target.value);
                            }}
                        />
                        {this.props.store.displayValidationErrors('email', this.validators)}
                        {!this.state.member.isAccountActivated && this.props.store.userInfo != null && this.props.store.userInfo.authType == "Admin" && this.state.member.id &&
                            <button className='blue-text blue-link link'
                                onClick={() => {
                                    Service.SendEmailConfirmation(this.state.member.id).then(res => {
                                        if (res.ok) {
                                            this.headerText = 'Success';
                                            this.dialogText = "Request is sent";
                                            this.dialogContent = <h4>{res.message}</h4>
                                            this.mode = 'success'
                                            this.setState({ showMessage: true });
                                        }
                                        else {
                                            this.headerText = 'Failure';
                                            this.dialogText = "Failed to send email confirmation request";
                                            this.dialogContent = <h4>{res.error ? res.error : 'Request is not sent'}</h4>
                                            this.mode = 'error'
                                            this.setState({ showMessage: true });
                                            return Promise.reject(new Error(res.message));
                                        }
                                    })
                                        .catch(err => {
                                            console.log(err);
                                        })
                                }}>
                                <span>Request confirmation</span>
                            </button>
                        }
                    </div>
                </li>
                <li className='input-wrapper'>
                    <p>Phone #:</p>
                    <div className={this.props.store.checkIfShowError('phone', this.validators) || this.props.store.checkIfShowError('phoneValid', this.validators) ? 'error-input-wrapper' : ""}>

                        <input
                            type='text'
                            placeholder='Phone Number'
                            value={this.state.member.phone}
                            onChange={e => {
                                this.props.store.updateValidators("phone", e.target.value, this.validators);
                                this.props.store.updateValidators("phoneValid", e.target.value, this.validators);
                                this.updateMemberProperty("phone", e.target.value)
                            }}
                        />
                        {this.props.store.displayValidationErrors('phoneValid', this.validators)}
                        {this.props.store.displayValidationErrors('phone', this.validators)}
                    </div>
                </li>
                <li className='input-wrapper'>
                    <p>Address:</p>
                    <div className={this.props.store.checkIfShowError('streetAddress', this.validators) ? 'error-input-wrapper' : ''}>
                        <input
                            type='text'
                            placeholder='Street Address'
                            value={this.state.member.streetAddress}
                            onChange={e => {
                                this.props.store.updateValidators("streetAddress", e.target.value, this.validators);
                                this.updateMemberProperty("streetAddress", e.target.value);
                            }}
                        />
                        {this.props.store.displayValidationErrors('streetAddress', this.validators)}
                    </div>
                </li>
                <li>
                    <span className='empty'></span>
                    <ul className='input-fields flex-nowrap break-at-560 line-of-inputs-wrapper'>
                        {/*<li
                            className='input-wrapper'
                            style={{ "flex": "1 1 auto" }}
                        >
                            <input
                                type='text'
                                placeholder='City'
                                value={this.state.member.city}
                                onChange={e => this.updateMemberProperty("city", e.target.value)}
                            />
                        </li>*/}
                        <li style={{ "flex": "1 1 auto" }}>

                            <div className={this.props.store.checkIfShowError('city', this.validators) ? 'error-input-wrapper' : ''} >
                                <input
                                    type='text'
                                    placeholder='City'
                                    value={this.state.member.city}
                                    onChange={e => {
                                        this.props.store.updateValidators("city", e.target.value, this.validators);
                                        this.updateMemberProperty("city", e.target.value);
                                    }}
                                />
                                {this.props.store.displayValidationErrors('city', this.validators)}
                            </div>
                        </li>
                        <li style={{ "flex": "1 0 150px" }}>
                            <div className={this.props.store.checkIfShowError('state', this.validators) ? 'error-input-wrapper' : ''} >
                                <MultiDropDown
                                    ref={el => this.stateDropDownRef = el}
                                    list={stateList}
                                    multiSelect={false}
                                    keyProperty='abbreviation'
                                    textProperty='abbreviation'
                                    defaultValue={this.state.member.state}
                                    placeholder="State"
                                    textPropertyRender={(element, textProperty) => this.stateNameAndAbbrRender(element, textProperty)}
                                    onDropDownValueChange={value => {
                                        this.props.store.updateValidators("state", value, this.validators);
                                        this.updateMemberProperty("state", value);
                                    }}
                                    search={this.filterList}
                                    searchParams={['abbreviation', 'name']}
                                //searchMinCharacterCount = {5}
                                />
                                {this.props.store.displayValidationErrors('state', this.validators)}
                            </div>
                        </li>
                        <li style={{ "flex": "0 0 100px" }}>
                            <div className={this.props.store.checkIfShowError('zip', this.validators) ? 'error-input-wrapper' : ''} >
                                <input
                                    type='text'
                                    placeholder='Zip'
                                    maxLength={5}
                                    value={this.state.member.zip}
                                    onChange={e => {
                                        this.props.store.updateValidators("zip", e.target.value, this.validators);
                                        this.updateMemberProperty("zip", e.target.value);
                                    }}
                                />
                                {this.props.store.displayValidationErrors('zip', this.validators)}
                            </div>
                        </li>
                    </ul>
                </li>
                <li>
                    <p className='mark-optional'>Comments:</p>
                    <div className='input-button-wrapper'>
                        <textarea
                            value={this.state.member.comments}
                            onChange={(evt) => this.updateMemberProperty("comments", evt.target.value)}
                        />
                    </div>
                </li>
            </ul>
        </div>;
    }

    getEventsTab = () => {
        return <MemberEvents events={this.state.member.events} />;
    }

    getOrdersTab = () => {
        return <MemberEventOrders openedFromProfile={true} userId={this.state.member.id} />;
    }

    render() {
        var tabToRender = this.getTabToRender();
        //const pictures = this.state.formattedPicturesList;
        return (
            <div className='pages-wsm-wrapper ipw-800'>
                <div className='second-nav-wrapper'>
                    <div className='ipw-600'>
                        <div></div>
                        <div className='flex-nowrap'>
                            <button
                                className='round-button medium-round-button outline-on-hover'
                                onClick={() => this.setState({ showDeleteMemberDialog: true })}
                            >
                                <DeleteUpSVG />
                                <span>Delete</span>
                            </button>
                            <button
                                className='round-button medium-round-button outline-on-hover'
                                onClick={this.saveMemberInfo}
                            >
                                <SaveUpSVG />
                                <span>Save</span>
                            </button>
                            <button
                                className='round-button medium-round-button outline-on-hover'
                                onClick={this.close}
                            >
                                <ReturnUpSVG />
                                <span>Exit</span>
                            </button>
                        </div>
                    </div>
                </div>
                {this.state.loading && <Loader />}
                {this.renderHeader()}
                <div className='flex-nowrap justify-center align-center mb-3 w-100'>
                    <TabComponent
                        fixedHeight={true}
                        tabList={this.getTabs()}
                        wasSelected={index => this.performIfValid(() => this.setState({ activeTabIndex: index }))}
                        activeTabIndex={this.state.activeTabIndex}
                    />
                </div>

                {tabToRender}

                {/*this.state.activeTabIndex === 3 &&
                    <MemberTRRInfo
                        setJoinDateDropDownRef={el => this.joinDateDropDownRef = el}
                        setStatusDropDownRef={el => this.statusDropDownRef = el}
                        setAuthLevelDropDownRef={el => this.authLevelDropDownRef = el}
                        setUserTypeDropDownRef={el => this.userTypeDropDownRef = el}
                        member={this.state.member}
                        updateMemberProperty={(property, value) => this.updateMemberProperty(property, value)}
                        roles={this.state.authLevels}
                    />
                }
                {this.state.activeTabIndex === 4 &&
                    <MemberOptions member={this.state.member} />
                */}
                <div className='flex-nowrap justify-center children-width-30 w-100 mt-2'>
                    {this.state.activeTabIndex > 0 &&
                        <button
                            className='medium-static-button static-button'
                            onClick={() => this.performIfValid(() => this.setState({ activeTabIndex: this.state.activeTabIndex - 1 }))}
                        > Back </button>
                    }
                    {((this.state.activeTabIndex < 2 && this.props.openedFromProfile) || this.state.activeTabIndex < 1) &&
                        <button
                            className='medium-static-button static-button default-button'
                            onClick={() => this.performIfValid(() => this.setState({ activeTabIndex: this.state.activeTabIndex + 1 }))}
                        > Next </button>
                    }
                </div>

                {this.state.showError && this.alertNotValid}
                {this.state.showMessage && showMessage(this.headerText, this.dialogText, this.dialogContent, this.mode, () => this.setState({ showMessage: false }))}

                {this.state.showDeleteMemberDialog &&
                    <Alert
                        headerText='Delete'
                        text='Are you sure you want to delete this Member?'
                        onClose={() => this.setState({ showDeleteMemberDialog: false })}
                        showOkCancelButtons={true}
                        onCancelButtonClick={() => this.setState({ showDeleteMemberDialog: false })}
                        onOkButtonClick={() => { this.deleteMember() }}
                        cancelButtonText="Cancel"
                        okButtonText="Delete"
                        mode='warning'
                    >
                        <h4 className='mb-05'>{this.state.member.firstName + ' ' + this.state.member.lastName}</h4>
                        <p style={{ "textAlign": "center" }}>This action cannot be undone. Delete anyway?</p>
                    </Alert>
                }

                {this.state.showSuccessfullySavedDialog &&
                    <Alert
                        headerText='Success'
                        onClose={() => this.setState({ showSuccessfullySavedDialog: false })}
                        showOkButton={true}
                        onOkButtonClick={() => this.setState({ showSuccessfullySavedDialog: false })}
                        okButtonText="Ok"
                        mode='success'
                    >
                        <h4 className='mb-05'>{this.state.member.firstName + ' ' + this.state.member.lastName}</h4>
                        <p style={{ "textAlign": "center" }}> Was successfully saved </p>
                    </Alert>
                }

                {this.state.showErrorSaveDialog &&
                    <Alert
                        headerText='Error'
                        onClose={() => this.setState({ showErrorSaveDialog: false })}
                        showOkButton={true}
                        onOkButtonClick={() => this.setState({ showErrorSaveDialog: false })}
                        okButtonText="Ok"
                        mode='error'
                    >
                        <p className='mb-05' style={{ "textAlign": "center" }}> {this.state.messageErrorSaveDialog} </p>
                        <h4 className='mb-05'>{this.state.member.firstName + ' ' + this.state.member.lastName}</h4>
                        <p style={{ "textAlign": "center" }}> was not saved </p>
                    </Alert>
                }

            </div>
        );
    }
}

export default withStore(Member);


// WEBPACK FOOTER //
// ./src/components/member/Member.jsx